export class FieldHandler {
  /**
   * Internap fields
   *
   * @type {string[]}
   * @memberof Fieldandler
   */
  public fields: string[] = [];

  constructor(withAllProperty = false) {
    if (withAllProperty) {
      this.addFullRelation();
    }
  }

  /**
   * Symbol that separates fields
   *
   * @private
   * @static
   * @memberof Fieldandler
   */
  private static readonly fieldSeparator = ',';

  /**
   * Symbol that mean append
   *
   * @private
   * @static
   * @memberof Fieldandler
   */
  private static readonly fieldAppendSymbol = '.';

  /**
   * Symbol that means all field
   *
   * @private
   * @static
   * @memberof Fieldandler
   */
  private static readonly allFieldsSymbol = '*';

  /**
   * Add's a simple field. * if empty
   *
   *
   * @param {(string | string[])} [fields]
   * @memberof Fieldandler
   */
  public add(fields: string | string[] = FieldHandler.allFieldsSymbol) {
    fields instanceof Array ? this.fields.push(...fields) : this.fields.push(fields);
  }

  /**
   * Add's relation.
   *
   * @param {string} relation
   * @param {(string | string[])} [fields=Fieldandler.allFieldsSymbol]
   * @memberof Fieldandler
   */
  public addRelation(relation: string, fields: string | string[] = FieldHandler.allFieldsSymbol) {
    fields instanceof Array
      ? this.fields.push(...fields.map((field) => `${relation}${FieldHandler.fieldAppendSymbol}${field}`))
      : this.fields.push(`${relation}${FieldHandler.fieldAppendSymbol}${fields}`);
  }

  /**
   * Add's relation with * on the end.
   *
   * @param {(string | string[])} [relations=Fieldandler.allFieldsSymbol]
   * @memberof Fieldandler
   */
  public addFullRelation(relations?: string | string[]) {
    if (relations) {
      relations instanceof Array
        ? this.fields.push(
            ...relations.map((field) => `${field}${FieldHandler.fieldAppendSymbol}${FieldHandler.allFieldsSymbol}`)
          )
        : this.fields.push(`${relations}${FieldHandler.fieldAppendSymbol}${FieldHandler.allFieldsSymbol}`);
    } else {
      this.fields.push(`${FieldHandler.allFieldsSymbol}`);
    }

    return this;
  }

  /**
   * Public getter.
   *
   * @returns
   * @memberof Fieldandler
   */
  public toString() {
    return this.fields.join(FieldHandler.fieldSeparator);
  }
}
